import GradeLessonPage from '../components/GradeLessonPage';
import { grade5Topics } from './data';

export default function Grade5Page() {
  return (
    <GradeLessonPage
      grade="5"
      gradeLabel="Grade 5"
      gradeColor="teal"
      topics={grade5Topics}
      prevGrade={{ label: 'Grade 4', path: '/grade/4' }}
      nextGrade={{ label: 'Grade 6', path: '/grade/6' }}
    />
  );
}
